export default __webpack_public_path__ + "static/media/nft1.156b1dff.jpg";